export enum AssignmentTab {
  HOMEWORK = 'homework',
  ASSESSMENT = 'standard-based assessments',
  TAKE_HOME_PROJECT = 'take-home projects',
}

export enum StudentAssignmentStatus {
  UPCOMING = 'upcoming',
  SUBMITTED = 'submitted',
  MISSED = 'missed',
}

export enum StudentAssessmentStatus {
  CURRENT = 'current',
  SUBMITTED = 'submitted',
  MISSED = 'missed',
}

export enum AssignmentAction {
  REUSE = 'reuse',
  ADD = 'add',
  UPDATE = 'update',
}

export enum AnswerType {
  ALL = 'all',
  TEXT = 'text',
  MCQ = 'mcq',
  GRAPHICAL = 'graphical',
}

export enum CreateAssignmentTab {
  CREATE_MANUALLY = 'Create Manually',
  AI_AUTO_GENERATE = 'AI Auto Generate',
  QUESTION_BANK = 'Question Bank',
  HOMEWORK_QUESTIONS_FROM_LESSON = 'Homework Questions from Lesson',
}

export enum QuestionFormat {
  MCQ = 1,
  TEXT = 2,
  GRAPHICAL = 3,
}

export enum PdfType {
  ASSIGNMENT = 'assignment',
  ASSESSMENT = 'assessment',
}

export enum CharacterLimits {
  FILE_NAME = 100,
}

export enum DummyAssignmentId {
  FIRST = 378,
  SECOND = 379,
}

export enum FilterType {
  ALL = 'all',
  CORRECT = 'correct',
  INCORRECT = 'incorrect',
}
